// Role-based wording for donations, derived from the RECEIVER's role.
//   preacher   → "Offrande" (feminine)  ·  recurring church gift → "Dîme"
//   artist     → "Soutien"  (masculine)
//   influencer → "Don"      (masculine)
// All human strings are i18n keys (pass `t`); French is the built-in fallback so
// the module still reads correctly when a translator is not supplied.
const CATEGORY_BY_ROLE = { preacher: "offrande", artist: "soutien", influencer: "don" };
const ROLE_LABEL_FR = { preacher: "prédicateur", artist: "artiste", influencer: "influenceur" };
const IS_DON = { offrande: false, don: true, soutien: true, dime: false };

// French fallbacks per category field.
const FB = {
  offrande: { Plural: "Offrandes", plural: "offrandes", singular: "offrande", on: "activées", off: "désactivées", received: "reçues", cta: "Faire une offrande", verb: "Offrir", accept: "Accepter les offrandes", goal: "Objectif d'offrande", desc: "Une offrande", recurring: "Offrande mensuelle" },
  don: { Plural: "Dons", plural: "dons", singular: "don", on: "activés", off: "désactivés", received: "reçus", cta: "Faire un don", verb: "Donner", accept: "Accepter les dons", goal: "Objectif de don", desc: "Un don", recurring: "Don mensuel" },
  soutien: { Plural: "Soutiens", plural: "soutiens", singular: "soutien", on: "activés", off: "désactivés", received: "reçus", cta: "Soutenir", verb: "Soutenir", accept: "Accepter les soutiens", goal: "Objectif de soutien", desc: "Mon soutien", recurring: "Soutien mensuel" },
  dime: { verb: "Donner", desc: "Ma dîme", recurring: "Dîme mensuelle" },
};
const CAT_LABEL_FB = { don: "Don", offrande: "Offrande", dime: "Dîme", soutien: "Soutien" };

const _id = (k, f) => f;

// Translated wording field for a category (key `off.<cat>.<field>`).
function w(cat, field, t) {
  return (t || _id)(`off.${cat}.${field}`, (FB[cat] || {})[field] || "");
}

export function offeringWording(role, t) {
  const cat = CATEGORY_BY_ROLE[role] || "don";
  return {
    isDon: IS_DON[cat],
    category: cat,
    Plural: w(cat, "Plural", t), plural: w(cat, "plural", t), singular: w(cat, "singular", t),
    on: w(cat, "on", t), off: w(cat, "off", t), received: w(cat, "received", t),
    cta: w(cat, "cta", t), verb: w(cat, "verb", t),
    accept: w(cat, "accept", t), goal: w(cat, "goal", t),
  };
}

export function roleLabel(role, t) {
  if (!role || !ROLE_LABEL_FR[role]) return null;
  return (t || _id)(`role.${role}`, ROLE_LABEL_FR[role]);
}
// Back-compat alias (older imports).
export const roleLabelFr = (role, t) => roleLabel(role, t);

// Human label for a stored donation category (don / offrande / dime / soutien).
export function categoryLabel(cat, t) {
  return (t || _id)(`hist.cat_${cat}`, CAT_LABEL_FB[cat] || "Don");
}

// {label, verb, desc} for the category picker in the donate modals.
export function categoryMeta(cat, t) {
  return {
    label: (t || _id)(`hist.cat_${cat}`, CAT_LABEL_FB[cat] || cat),
    verb: w(cat, "verb", t),
    desc: w(cat, "desc", t),
  };
}

// Recurring title for a category, e.g. "Offrande mensuelle".
export function recurringLabel(cat, t) {
  return w(cat, "recurring", t);
}

// Categories the DONOR can choose from, based on the receiver's role.
//   preacher / church  → Dîme · Offrande · Soutien
//   artist / influencer→ Don · Soutien
export function allowedCategories(role, { recurring = false } = {}) {
  if (recurring || role === "preacher") return ["dime", "offrande", "soutien"];
  return ["don", "soutien"];
}
